module.exports = __webpack_public_path__ + "img/rss-jobmule.91048942.png";